import { Alert } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";

const ResetSuccess = () => (
   <Alert variant="success" showCloseButton={false}>
      Passordet ditt har blitt oppdatert. Du kan nå prøve å logge inn med nytt passord.
   </Alert>
);

export default observer(ResetSuccess);
